import React from 'react';

import { useAccount } from 'wagmi';

import { ChainSlug } from '@/constants';
import useChainByCurrency from '@/hooks/useChainByCurrency';
import { useBtcWallet } from '@/networks/btc-like/btc';
import { useDogeWallet } from '@/networks/btc-like/doge';
import { useLtcWallet } from '@/networks/btc-like/ltc';
import { useCoinwebWallet } from '@/networks/coinweb';
import { useTronWallet } from '@/networks/tron';
import { useSwapContext } from '@/pages/Swap/context';
import { useAdminStore } from '@/shared';

import HeaderWalletDrawerBtcWallet from './HeaderWalletDrawerBtcWallet';
import HeaderWalletDrawerCwebWallet from './HeaderWalletDrawerCwebWallet';
import HeaderWalletDrawerDogeWallet from './HeaderWalletDrawerDogeWallet/HeaderWalletDrawerDogeWallet';
import HeaderWalletDrawerEvmWallet from './HeaderWalletDrawerEvmWallet';
import HeaderWalletDrawerLtcWallet from './HeaderWalletDrawerLtcWallet';
import HeaderWalletDrawerTronWallet from './HeaderWalletDrawerTronWallet';

const HeaderWalletDrawerWallets: React.FC = () => {
  const { isAdmin } = useAdminStore();

  const { tokenFrom } = useSwapContext();
  const { chainSlug } = useChainByCurrency(tokenFrom);

  const { isConnected: isBTCConnected } = useBtcWallet();
  const { isConnected: isEVMConnected } = useAccount();
  const { isConnected: isTronConnected } = useTronWallet();
  const { isConnected: isLtcConnected } = useLtcWallet();
  const { isConnected: isDogeConnected } = useDogeWallet();
  const { isConnected: isCoinwebConnected } = useCoinwebWallet();

  return (
    <div className="flex flex-col items-center justify-end gap-2 leading-4">
      {[
        { key: ChainSlug.BTC, connected: isBTCConnected, element: <HeaderWalletDrawerBtcWallet /> },
        { key: ChainSlug.EVM, connected: isEVMConnected, element: <HeaderWalletDrawerEvmWallet /> },
        { key: ChainSlug.TRON, connected: isTronConnected, element: <HeaderWalletDrawerTronWallet /> },
        { key: ChainSlug.LTC, connected: isLtcConnected, element: <HeaderWalletDrawerLtcWallet /> },
        { key: ChainSlug.DOGE, connected: isDogeConnected, element: <HeaderWalletDrawerDogeWallet /> },
        isAdmin
          ? {
              key: ChainSlug.CWEB,
              connected: isCoinwebConnected,
              element: <HeaderWalletDrawerCwebWallet />,
            }
          : null,
      ]
        .filter((item): item is NonNullable<typeof item> => !!item)
        .sort((a, b) => {
          if (a.key === chainSlug && b.key !== chainSlug) return -1;
          if (a.key !== chainSlug && b.key === chainSlug) return 1;
          return 0;
        })
        .sort((a, b) => Number(!!a.connected) - Number(!!b.connected))
        .map((item) => (
          <React.Fragment key={item.key.concat('-drawer-wallet')}>{item.element}</React.Fragment>
        ))}
    </div>
  );
};

export default HeaderWalletDrawerWallets;
